export default "__VITE_PUBLIC_ASSET__7cad2c45__"